import React from "react";
import { Star } from "lucide-react";
import { Card } from "../ui/card";

const FacebookLogo = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const GoogleLogo = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

export default function ReviewsSection() {
  const reviews = [
    {
      name: "Carina Larsson",
      rating: 5,
      text: "Unnade mig en fantastiskt härlig stund med ansiktsbehandling med färg och form av bryn och fransar. Även en härlig massage ingick. Jag blev så nöjd och jag rekommenderar varmt ett besök hos Milepa. Ett varmt omhändertagande och proffsigt resultat gör att jag återvänder",
      source: "Google",
      therapist: "Julia"
    },
    {
      name: "Emmy F.",
      rating: 5,
      text: "Fantastiskt bemötande av Julia, jag var ny kund där o hon fick mig att känna mej SÅ avslappnad o trygg! Aldrig varit med om något liknande ! PROffsigast i stan -om det räcker ?! 🌟🌟🌟🌟🌟🌟",
      source: "Bokadirekt",
      therapist: "Julia"
    },
    {
      name: "Marina G.",
      rating: 5,
      text: "Stort tack för en fantastisk behandling, underbara Julia! Jag är så nöjd med resultaten och hur min hud känns och ser ut efteråt. Det var verkligen en lyxig upplevelse och jag ser fram emot att komma tillbaka för fler behandlingar. Tack för ditt professionalism och expertis!",
      source: "Bokadirekt",
      therapist: "Julia"
    },
    {
      name: "Sofia D.",
      rating: 5,
      text: "Victoria är så duktig och professionell! Efter två behandlingar med diatermi och plasmapen känner jag mig helt trygg hos Victoria. 🌟",
      source: "Bokadirekt",
      therapist: "Victoria"
    },
    {
      name: "Therese A.",
      rating: 5,
      text: "Victoria är alltid lika trevlig och mycket professionell i sitt yrke! Mysig salong och man känner sig alltid välkommen av både Julia och Victoria!",
      source: "Bokadirekt",
      therapist: "Victoria"
    },
    {
      name: "Moa V.",
      rating: 5,
      text: "Jag har gått till Victoria i snart 2 år och hon är helt fantastiskt. Gör ett superbra jobb och får mig alltid att känna mig bekväm och välkommen. Jag har också gått hos Julia som är minst lika fantastiskt! Jag rekommenderar varmt att besöka Milepa",
      source: "Bokadirekt",
      therapist: "Victoria & Julia"
    }
  ];

  const platformStats = [
    { 
      name: "Google", 
      rating: 4.9, 
      reviews: 47,
      logo: GoogleLogo,
      link: "https://www.google.com/search?sa=X&sca_esv=6a46622504ef503e&tbm=lcl&sxsrf=AE3TifOR2BrkuP2s9bmBgvuPypz7J2JeGQ:1759245904665&q=Salong+Milepa+Reviews&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxtDAwNjQxMbc0MzYwMzWxALJMNjAyvmIUDU7Myc9LV_DNzEktSFQISi3LTC0vXsSKXRwAAg05eEsAAAA&rldimm=18031447963065484794&hl=en-SE&ved=2ahUKEwjTm-HZ5YCQAxWvHxAIHfUuMSMQ9fQKegQIXhAH&biw=1144&bih=1304&dpr=1#lkt=LocalPoiReviews"
    },
    { 
      name: "Bokadirekt", 
      rating: 4.9, 
      reviews: 1825,
      logo: null,
      link: "https://www.bokadirekt.se/places/salong-milepa-13263#reviews"
    },
    { 
      name: "Facebook", 
      rating: 4.9, 
      reviews: 43,
      logo: FacebookLogo,
      link: "https://www.facebook.com/MilepaBeautiful/reviews"
    }
  ];

  const totalReviews = 1900;
  const averageRating = 4.9;

  const getSourceColor = (source) => {
    if (source === "Google") return { bg: 'rgba(66, 133, 244, 0.1)', text: '#4285F4' };
    if (source === "Facebook") return { bg: 'rgba(24, 119, 242, 0.1)', text: '#1877F2' };
    return { bg: 'rgba(69, 140, 125, 0.1)', text: '#458c7d' };
  };

  const getSourceLogo = (source) => {
    if (source === "Google") return GoogleLogo;
    if (source === "Facebook") return FacebookLogo;
    return null;
  };

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-light mb-4 text-gray-800">
            Över <span className="font-bold" style={{ color: 'var(--primary)' }}>{totalReviews}+</span> Nöjda Kunder
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
            Med över tio års erfarenhet i branschen har vi byggt upp ett stort förtroende bland våra kunder. 
            Idag är vi stolta över att vara en av de högst rankade salongerna i Helsingborg.
          </p>
          
          {/* Platform Stats */}
          <div className="flex flex-wrap justify-center gap-8 mb-8">
            {platformStats.map((platform, index) => (
              <a
                key={index}
                href={platform.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center gap-2 hover:scale-105 transition-transform duration-300"
              >
                {platform.logo && (
                  <div className="w-12 h-12 rounded-full bg-white shadow-md flex items-center justify-center">
                    <platform.logo />
                  </div>
                )}
                <div className="text-center">
                  <div className="flex items-center gap-1 mb-1">
                    <Star className="w-5 h-5 fill-current" style={{ color: 'var(--secondary)' }} />
                    <span className="font-bold text-lg text-gray-800">{platform.rating}</span>
                  </div>
                  <p className="text-sm font-semibold text-gray-700">{platform.name}</p>
                  <p className="text-xs text-gray-500">{platform.reviews} recensioner</p>
                </div>
              </a>
            ))}
          </div>

          <div className="inline-block bg-gradient-to-r from-[var(--primary)] to-[var(--secondary)] text-white px-6 py-3 rounded-full">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className={`w-5 h-5 ${i < 4 ? 'fill-current' : 'fill-current opacity-90'}`} />
                ))}
              </div>
              <span className="text-xl font-bold">{averageRating}</span>
              <span className="text-sm opacity-90">genomsnittligt betyg</span>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {reviews.map((review, index) => {
            const SourceLogo = getSourceLogo(review.source);
            const colors = getSourceColor(review.source);
            
            return (
              <Card 
                key={index}
                className="p-6 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border-none bg-white"
              >
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-current" style={{ color: 'var(--secondary)' }} />
                    ))}
                  </div>
                  <div 
                    className="flex items-center gap-1 px-3 py-1 rounded-full"
                    style={{ 
                      backgroundColor: colors.bg,
                      color: colors.text
                    }}
                  >
                    {SourceLogo && <SourceLogo />}
                    <span className="text-xs font-semibold">{review.source}</span>
                  </div>
                </div>
                
                <p className="text-gray-700 mb-4 leading-relaxed text-sm">"{review.text}"</p>
                
                <div className="flex items-center justify-between border-t pt-4">
                  <div>
                    <p className="font-semibold text-gray-800 text-sm">{review.name}</p>
                    <div className="flex items-center gap-2 mt-1">
                      {review.therapist && (
                        <span 
                          className="text-xs px-2 py-1 rounded-full"
                          style={{ 
                            backgroundColor: 'rgba(98, 195, 214, 0.1)',
                            color: 'var(--primary)'
                          }}
                        >
                          {review.therapist}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Call to Action */}
        <div className="text-center bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-semibold mb-4 text-gray-800">
            Bli en av våra nöjda kunder idag!
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Gå med tusentals andra som redan upptäckt vad som gör Salong Milepa så speciell. 
            Boka din tid nu och upplev skillnaden själv!
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="https://www.bokadirekt.se/places/salong-milepa-13263" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <button 
                className="bg-[var(--booking-green)] hover:bg-[#458c7d] px-8 py-4 rounded-full text-lg font-semibold text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
              >
                Boka Din Behandling
              </button>
            </a>
          </div>
          
          <div className="mt-6 flex flex-wrap justify-center gap-6 text-sm text-gray-600">
            <span>✓ 100% Verifierade recensioner</span>
            <span>✓ Certifierad personal</span>
            <span>✓ {totalReviews}+ nöjda kunder</span>
          </div>
        </div>

        {/* Links to Review Platforms */}
        <div className="text-center mt-8">
          <p className="text-gray-600 flex items-center justify-center gap-2 flex-wrap">
            <span>Läs alla våra recensioner på</span>
            <a 
              href="https://www.google.com/search?sa=X&sca_esv=6a46622504ef503e&tbm=lcl&sxsrf=AE3TifOR2BrkuP2s9bmBgvuPypz7J2JeGQ:1759245904665&q=Salong+Milepa+Reviews&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxtDAwNjQxMbc0MzYwMzWxALJMNjAyvmIUDU7Myc9LV_DNzEktSFQISi3LTC0vXsSKXRwAAg05eEsAAAA&rldimm=18031447963065484794&hl=en-SE&ved=2ahUKEwjTm-HZ5YCQAxWvHxAIHfUuMSMQ9fQKegQIXhAH&biw=1144&bih=1304&dpr=1#lkt=LocalPoiReviews" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 px-3 py-1 rounded-full hover:opacity-70 transition-opacity"
              style={{ backgroundColor: 'rgba(66, 133, 244, 0.1)', color: '#4285F4' }}
            >
              <GoogleLogo />
              <span className="text-xs font-semibold">Google</span>
            </a>
            {", "}
            <a 
              href="https://www.bokadirekt.se/places/salong-milepa-13263#reviews" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 px-3 py-1 rounded-full hover:opacity-70 transition-opacity"
              style={{ backgroundColor: 'rgba(69, 140, 125, 0.1)', color: '#458c7d' }}
            >
              <span className="text-xs font-semibold">Bokadirekt</span>
            </a>
            {" och "}
            <a 
              href="https://www.facebook.com/MilepaBeautiful/reviews" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 px-3 py-1 rounded-full hover:opacity-70 transition-opacity"
              style={{ backgroundColor: 'rgba(24, 119, 242, 0.1)', color: '#1877F2' }}
            >
              <FacebookLogo />
              <span className="text-xs font-semibold">Facebook</span>
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}